import { Grid, Card, CardHeader, CardContent, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { ReportProblem, LockPerson, Repeat, Block } from '@mui/icons-material';
import { useQuery } from '@tanstack/react-query';
import { PageHeader } from '../../components/PageHeader';
import { StatCard } from '../../components/StatCard';
import { EmptyState } from '../../components/EmptyState';
import { securityApi } from '../../api/security.api';

const n = (x = 0) => Number(x).toLocaleString('en-IN');

export function SecurityDashboardPage() {
  const dash = useQuery({ queryKey: ['security-dashboard'], queryFn: () => securityApi.dashboard() });
  const susp = useQuery({ queryKey: ['security-suspicious'], queryFn: () => securityApi.suspicious({ limit: 25 }) });
  const d = dash.data;

  return (
    <>
      <PageHeader title="Security Audit Dashboard" subtitle={`Failed logins, lockouts, token reuse and IP monitoring (last ${d?.windowDays ?? 7} days).`} />
      <Grid container spacing={2} mb={1}>
        <Grid item xs={6} sm={3}><StatCard gradient color="#d97706" label="Failed Logins" value={n(d?.failedLogins)} icon={<ReportProblem />} /></Grid>
        <Grid item xs={6} sm={3}><StatCard gradient color="#dc2626" label="Locked Accounts" value={n(d?.lockedAccounts)} icon={<LockPerson />} hint={`${n(d?.accountLocked)} lock events`} /></Grid>
        <Grid item xs={6} sm={3}><StatCard gradient color="#7c3aed" label="Token Reuse" value={n(d?.tokenReuse)} icon={<Repeat />} /></Grid>
        <Grid item xs={6} sm={3}><StatCard gradient color="#0d9488" label="Rate Limited" value={n(d?.rateLimited)} icon={<Block />} /></Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} md={5}>
          <Card sx={{ height: '100%' }}>
            <CardHeader title="Top Offending IPs" titleTypographyProps={{ variant: 'subtitle1' }} />
            <CardContent sx={{ p: 0, overflowX: 'auto' }}>
              {(d?.topIps.length ?? 0) === 0 ? <EmptyState title="No suspicious IPs" dense /> : (
                <Table size="small">
                  <TableHead><TableRow><TableCell>IP</TableCell><TableCell align="right">Events</TableCell></TableRow></TableHead>
                  <TableBody>{(d?.topIps ?? []).map((r) => <TableRow key={r.ip}><TableCell>{r.ip}</TableCell><TableCell align="right">{r.count}</TableCell></TableRow>)}</TableBody>
                </Table>
              )}
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={7}>
          <Card sx={{ height: '100%' }}>
            <CardHeader title="Suspicious Activity Log" titleTypographyProps={{ variant: 'subtitle1' }} />
            <CardContent sx={{ p: 0, overflowX: 'auto' }}>
              {(susp.data?.data.length ?? 0) === 0 ? <EmptyState title="No suspicious activity" dense /> : (
                <Table size="small">
                  <TableHead><TableRow><TableCell>Event</TableCell><TableCell>IP</TableCell><TableCell>When</TableCell></TableRow></TableHead>
                  <TableBody>
                    {(susp.data?.data ?? []).map((e) => (
                      <TableRow key={e.id} hover><TableCell>{e.event_type.replace(/_/g, ' ')}</TableCell><TableCell>{e.ip_address ?? '—'}</TableCell><TableCell>{new Date(e.created_at).toLocaleString()}</TableCell></TableRow>
                    ))}
                  </TableBody>
                </Table>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
}
